module.exports = __webpack_public_path__ + "img/CLOCK.31d8e51a.svg";